import { CATEGORIES_API_URL } from "../utils/shopApi";

/** Mobile drawer: main links (desktop row uses a subset + inline search). */
/** Drawer links (search + cart live on the mobile app bar). */
export const baseDrawerNavLinks = [
  { label: "Track", to: "/Track" },
  { label: "Contact Us", to: "/ContactUs" },
  { label: "Promotions", to: "/Promotions" },
  { label: "Brands", to: "/Brands" },
];

export const getDrawerNavLinks = (isAuthenticated) => [
  ...(isAuthenticated
    ? [{ label: "Profile", to: "/Profile" }]
    : [
        { label: "Sign in", to: "/SignIn" },
        { label: "Register", to: "/Register" },
      ]),
  ...baseDrawerNavLinks,
];

/** @deprecated Use getDrawerNavLinks(isAuthenticated) */
export const drawerNavLinks = getDrawerNavLinks(false);

export const promoBrandLinks = [
  { label: "Promotions", to: "/Promotions" },
  { label: "Brands", to: "/Brands" },
];

/** Services dropdown (desktop navbar + drawer menu). */
export const serviceMenuLinks = [
  { label: "Our Services", to: "/OurServices" },
  { label: "Wholesale Distribution", to: "/Wholesale_Distribution" },
  { label: "Export Services", to: "/Export_Services" },
  {
    label: "Logistics & Storage Solutions",
    to: "/Logistics_Storage_Solutions",
  },
  { label: "Customs Clearance", to: "/Customs_Clearance" },
];

const toSlug = (value = "") =>
  value
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const mapApiFilters = (filters = []) =>
  filters.map((filter) => ({
    id: filter?.id ?? null,
    label: filter?.name ?? "",
    slug: filter?.slug || toSlug(filter?.name ?? ""),
    sort_order: filter?.sort_order ?? 0,
  }));

export const mapApiCategoriesToShopCategories = (payload) => {
  const categories = Array.isArray(payload?.data) ? payload.data : [];
  return categories.map((category) => ({
    label: category?.name ?? "",
    slug: category?.slug || toSlug(category?.name ?? ""),
    subcategories: Array.isArray(category?.children)
      ? category.children.map((child) => ({
          label: child?.name ?? "",
          slug: child?.slug || toSlug(child?.name ?? ""),
          filters: mapApiFilters(child?.filters),
        }))
      : [],
  }));
};

export const findShopCategory = (categories, categorySlug) =>
  categories.find((entry) => entry.slug === categorySlug) ?? null;

export const findShopSubcategory = (categories, subcategorySlug) => {
  for (const category of categories) {
    const match = category.subcategories?.find(
      (entry) => entry.slug === subcategorySlug,
    );
    if (match) return match;
  }
  return null;
};

export const getFiltersForShopContext = (
  categories,
  { category = "", subcategory = "" } = {},
) => {
  if (subcategory) {
    const match = findShopSubcategory(categories, subcategory);
    return [...(match?.filters ?? [])].sort(
      (a, b) => a.sort_order - b.sort_order,
    );
  }

  if (category) {
    const match = findShopCategory(categories, category);
    const seen = new Set();
    const filters = [];

    (match?.subcategories ?? []).forEach((entry) => {
      (entry.filters ?? []).forEach((filter) => {
        if (!filter.slug || seen.has(filter.slug)) return;
        seen.add(filter.slug);
        filters.push(filter);
      });
    });

    return filters.sort((a, b) => a.sort_order - b.sort_order);
  }

  return [];
};

export const fetchShopCategories = async () => {
  const res = await fetch(CATEGORIES_API_URL);
  if (!res.ok) throw new Error("Failed to fetch categories");
  const payload = await res.json();
  return mapApiCategoriesToShopCategories(payload);
};
